import { Tick } from '@berlitz/icons'
import { Content } from '@components/ListCard/style'
import { Col } from 'react-styled-flexboxgrid'
import styled, { css } from 'styled-components'
import { _attention } from '@utils/mixins'

import Button from '@berlitz/button'
import { LessonInfoFooterProp, Uppercase } from './interface'

export const PendingButtons = styled.div`
  button {
    padding-top: ${({ theme }) => theme.space.xs};
    padding-bottom: ${({ theme }) => theme.space.xs};
  }

  .ghost {
    color: ${({ theme }) => theme.colors.brandPrimary};
    margin-top: ${({ theme }) => theme.space.xxs};
  }
`

export const CompletedTick = styled(Tick)`
  background-color: ${({ theme }) => theme.colors.brandSecondary};
  font-size: ${({ theme }) => theme.fontSize.xs};
  padding: ${({ theme }) => theme.space.xs};
  margin-left: ${({ theme }) => theme.space.xs};
  border-radius: 3px;
`
export const JoinLessonButton = styled(Button)`
  padding: ${({ theme }) => `${theme.space.xs} ${theme.space.lg}`};
  font-size: ${({ theme }) => theme.fontSize.xxs};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  background-color: ${({ theme }) => theme.colors.brandSecondary};
  border-radius: ${({ theme }) => theme.radius.md};
  border: none;
  color: ${({ theme }) => theme.palette.charcoal};

  ${({ theme }) =>
    _attention(css`
      background-color: ${theme.colors.brandSecondary};
      transition: 0.4s;
      opacity: 0.8;
    `)};
`

export const GroupName = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;

  svg {
    margin-top: ${({ theme }) => theme.space.xs};
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    svg {
      margin-top: 0;

      &:first-child {
        margin-left: ${({ theme }) => theme.space.xxs};
      }
    }
  }
`

export const ActionBox = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;

  &.with-report {
    width: 100%;
  }

  button {
    padding-top: ${({ theme }) => theme.space.xs};
    padding-bottom: ${({ theme }) => theme.space.xs};
    padding-left: ${({ theme }) => theme.space.sm};
    padding-right: ${({ theme }) => theme.space.sm};
    margin-left: ${({ theme }) => theme.space.xs};
  }

  ${CompletedTick} {
    display: none;
  }

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    &.with-report {
      width: max-content;

      button {
        &:first-child {
          margin-right: ${({ theme }) => theme.space.xs};
        }
      }
    }

    ${CompletedTick} {
      display: block;
    }
  }
`

export const Bold = styled.span<Uppercase>`
  font-size: ${({ theme }) => theme.fontSize.xs};
  font-weight: ${({ theme }) => theme.fontWeight.bold};
  display: inline-flex;
  align-items: center;

  ${({ uppercase }) =>
    uppercase &&
    css`
      text-transform: uppercase;
    `}

  svg {
    margin-right: ${({ theme }) => theme.space.xs};
    color: ${({ theme }) => theme.palette.blueGray60};
  }
`

export const Note = styled.div`
  margin-top: ${({ theme }) => theme.space.xs};
`

export const IconStatus = styled.div`
  display: block;

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    display: none;
  }
`

export const Indicators = styled.div`
  margin-right: ${({ theme }) => theme.space.md};
  display: flex;

  a {
    cursor: pointer;
  }

  svg {
    margin-left: ${({ theme }) => theme.space.sm};
  }
`

export const NoteCol = styled(Col)`
  padding: ${({ theme }) => theme.space.sm};
  background-color: ${({ theme }) => theme.palette.info10};
`

export const LessonInfoFooter = styled.div<LessonInfoFooterProp>`
  border-top: 1px solid ${({ theme }) => theme.palette.gray40};
  padding: ${({ theme }) => theme.space.sm};
  overflow-y: auto;

  ${({ isAtRisk }) =>
    isAtRisk &&
    css`
      border-top: 1px solid #d87515 !important;
    `}

  ${({ error }) =>
    error &&
    css`
      border-color: ${({ theme }) => theme.palette.danger100};
    `}
  ${({ isBoD1 }) =>
    isBoD1 &&
    css`
      ::-webkit-scrollbar {
        -webkit-appearance: none;
        width: 7px;
      }

      ::-webkit-scrollbar-thumb {
        border-radius: 4px;
        background-color: rgba(0, 0, 0, 0.5);
        box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
      }
    `}

  ${Col} {
    padding-left: 0;
    padding-right: 0;
  }

  ${NoteCol} {
    padding: ${({ theme }) => theme.space.sm};
  }

  label {
    font-size: ${({ theme }) => theme.fontSize.xs};
    font-weight: ${({ theme }) => theme.fontWeight.bold};
    margin-right: ${({ theme }) => theme.space.xs};
  }

  p {
    font-size: ${({ theme }) => theme.fontSize.xxs};
    margin-bottom: ${({ theme }) => theme.space.xs};
  }
`

export const LessonInfoBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
`

export const Box = styled.div`
  margin-top: ${({ theme }) => theme.space.lg};

  @media (min-width: ${({ theme }) => theme.breakpoints.lg}) {
    margin-top: ${({ theme }) => theme.space.xxxs};
  }

  .text-center {
    text-align: center;
  }

  ${Content} {
    padding: 0;
  }

  .complete-tick {
    margin-left: ${({ theme }) => theme.space.xs};
  }
`

export const StyledMINote = styled.div`
  margin-right: ${({ theme }) => theme.space.xs};
`

export const SelfTechCheckWrapper = styled.div`
  margin-top: ${({ theme }) => theme.space.xs};
  flex: 1 0 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-end;
`

export const MIContainer = styled.div`
  cursor: pointer;
`

export const EventButtonsWrapper = styled.div`
  ${({ theme }) => `
      width: 100%;
      display: flex;
      flex-direction: row-reverse;
      justify-content: center;
      align-items: center;

    a {
      color: ${theme.colors.brandPrimary};
      font-size: 14px;
      font-weight: 500;
      font-stretch: normal;
      font-style: normal;
      line-height: normal;
      letter-spacing: normal;
      text-align: right;
      text-decoration: underline;
      cursor: pointer;
        margin-top: 0px;
        margin-right: 8px;
    }

    @media (min-width: ${theme.breakpoints.lg}) {
      flex-direction: column;
      align-items: flex-end;

      a {
        margin-top: 4px;
        margin-right: 8px;
      }
    }
  `}
`
